// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00242833","239":"dad884e9","455":"a8cd4406"}[chunkId] + ".chunk.js";
};